export const VESSEL_ARRIVAL_LABEL = {
  header: 'Vessel Arrival',
  code1: 'Origin Code',
  code2: 'Arrival Code',
  port1: 'Port of Origin',
  port2: 'Port of Arrival',
  name1: 'Origin Name',
  name2: 'Arrival Name',
  country1: 'Origin Country',
  country2: 'Arrival Country',
};

export const VESSEL_DEPARTURE_LABEL = {
  header: 'Vessel Departure',
  code1: 'Departure Code',
  code2: 'Destination Code',
  port1: 'Port of Departure',
  port2: 'Port of Destination',
  name1: 'Departure Name',
  name2: 'Destination Name',
  country1: 'Departure Country',
  country2: 'Destination Country',
};

export const CARGO_COLLECTION_LABEL = {
  title: 'Cargo Collection Form',
  location: 'Container Collection Location',
  additional_doc: {
    title: 'Cargo Collection Additional Document',
    location: 'Container Collection',
  },
};

export const CARGO_DELIVERY_LABEL = {
  title: 'Cargo Delivery Form',
  location: 'Container Delivery Location',
  additional_doc: {
    title: 'Cargo Delivery Additional Document',
    location: 'Container Delivery',
  },
};
